// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadcrumbItem_container__Dvssx","itemText":"BreadcrumbItem_itemText__nKhIj","currentPage":"BreadcrumbItem_currentPage__AHxPV"};